import PropTypes, { oneOfType } from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Menu, { setActiveItems } from './Menu';
import MenuItem from './MenuItem';
import DownChevron from '../../../img/sprite/down-chevron.svg';
import {
  PATH_PROFILE,
  PATH_USER_ADDRESS_MANAGEMENT,
  PATH_ORDER_HISTORY,
  PATH_GIFT_CARDS,
  PATH_DIGITAL_MEDIA,
  PATH_SUBSCRIPTIONS,
  PATH_MANAGE_ACCESS,
  PATH_AUTOSHIP,
  PATH_PAYMENT_METHODS,
  ENABLE_SIDENAV_MENU,
  PATH_PERSONAL_ACCOUNT,
  ENABLE_ORG_MANAGEMENT
} from '../constants';
import { RedeemButton } from './RedeemButton';

const SharedIconStyles = css`
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  li  li & {
    display: none;
  }
`;

const ActiveIcon = styled.svg`
  ${SharedIconStyles}
  margin-left: 0.692em;
  margin-top: -0.308em;
`;

const InactiveIcon = styled.svg`
  ${SharedIconStyles}
  margin-left: 0.462em;
  margin-top: -0.231em;
  transform: rotate(-90deg);
`;

const NavHeader = styled.h1`
  font-size: 11px;
  font-weight: 600;
  color: #999999;
  text-transform: uppercase;
`;



export default class PersonNavMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAccountSubItems: false,
      showAccountSettings: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    // only render once every location change
    if (nextProps.location !== this.props.location || JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }
    return nextProps.noRender !== this.props.noRender;
  }

  updateShowAccountSubItems = () => {
    const { showAccountSubItems } = this.state;
    this.setState({
      showAccountSubItems: !showAccountSubItems
    });
  }
  updateShowAccountSettings = () => {
    const { showAccountSettings } = this.state;
    this.setState({
      showAccountSettings: !showAccountSettings
    });
  }

  updateShowPaymentSubItems = () => {
    const { showPaymentSubItems } = this.state;
    this.setState({
      showPaymentSubItems: !showPaymentSubItems
    });
  }

  render() {
    const { location, isOpen, navToggle, isMobile } = this.props;
    const { showAccountSubItems, showAccountSettings } = this.state;

    const styles = this.props.styles || {};
    const icons = this.props.icons || {
      activeIcon: <ActiveIcon><use xlinkHref={`#${DownChevron.id}`} /></ActiveIcon>,
      inactiveIcon: <InactiveIcon><use xlinkHref={`#${DownChevron.id}`} /></InactiveIcon>
    };
    const NavItem = (props) => <MenuItem location={location} icons={icons} styles={styles} navToggle={navToggle} isOpen={isOpen} {...props} />;
    const NavList = (props) => <Menu styles={styles} {...props} />;

    const isOnOrg = location.pathname.match('(billing-account.*?(order-history.*?|account-activity))');

    const updatedMenu = (
      <NavList isActive>
        <NavHeader>My Account</NavHeader>
        <NavItem title="Order History" href={PATH_ORDER_HISTORY} data-qa-hook="orgManagementOrderHistory.link" isChild={true} />
        <NavItem title="Autoship" href={PATH_AUTOSHIP} data-qa-hook="autoShip.link" isChild={true}/>
        <NavItem title="Subscriptions" href={PATH_SUBSCRIPTIONS} data-qa-hook="subscriptions.link" isChild={true} />
        <NavItem title="Digital Library" href={PATH_DIGITAL_MEDIA} data-qa-hook="mediaContent.link" isChild={true}/>
        <NavItem title="Manage Access" href={PATH_MANAGE_ACCESS} data-qa-hook="manageAccss.link" isChild={true}/>

        <NavHeader>My Settings</NavHeader>
        <NavItem title="Profile" href={PATH_PROFILE} data-qa-hook="profile.link" isChild={true} />
        <NavItem title="Addresses" href={PATH_USER_ADDRESS_MANAGEMENT} data-qa-hook="shippingAddresses.link" isChild={true} />
        <NavItem title="Payment Methods" href={PATH_PAYMENT_METHODS} data-qa-hook="creditCards.link" isChild={true} />
        <NavItem title="Gift Cards" href={PATH_GIFT_CARDS} data-qa-hook="paymentMethodsGiftCards.link" isChild={true} />

        <RedeemButton />
      </NavList>
    );

    const menu = (
      isMobile ? (
        // MOBILE NAV //
          <NavList isActive dropDown={ENABLE_SIDENAV_MENU ? true : false}>
            <NavItem firstChild title="My Account" btnClick={this.updateShowAccountSubItems} showChildren={showAccountSubItems} data-qa-hook="personalAccount.link">
              <NavList showChildren={showAccountSubItems}>
                <NavItem title="Profile" href={PATH_PROFILE} data-qa-hook="profile.link" isChild={true} />
                <NavItem title="Addresses" href={PATH_USER_ADDRESS_MANAGEMENT} data-qa-hook="shippingAddresses.link" isChild={true} />
                <NavItem title="Subscriptions" href={PATH_SUBSCRIPTIONS} data-qa-hook="subscriptions.link" isChild={true} />
                <NavItem title="Payment Methods" href={PATH_PAYMENT_METHODS} data-qa-hook="creditCards.link" isChild={true} />
                <NavItem title="Gift Cards" href={PATH_GIFT_CARDS} data-qa-hook="paymentMethodsGiftCards.link" isChild={true} />
              </NavList>
            </NavItem>
            <NavItem title="Orders & Autoship" href={PATH_ORDER_HISTORY} auxiliaryRoutes={[PATH_AUTOSHIP]} data-qa-hook="orderHistory.link" />
            <NavItem title="Digital Library" href={PATH_DIGITAL_MEDIA} data-qa-hook="mediaContent.link" />
            <NavItem title="Manage Access" href={PATH_MANAGE_ACCESS} data-qa-hook="manageAccss.link" />
            {!ENABLE_ORG_MANAGEMENT && (
              isOnOrg ?
                <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link">
                  <NavList dropDown={ENABLE_SIDENAV_MENU ? true : false}>
                    <NavItem title="All Accounts" href={`${PATH_ORG_MGMT}/billing-accounts`} data-qa-hook="orgManagement.link" isChild={true} />
                    <NavItem title="Order History" href={regExBillingAccountPathHelper(location.pathname, 'order-history')} data-qa-hook="orgManagementOrderHistory.link" isChild={true} />
                    <NavItem title="Account Activity" href={regExBillingAccountPathHelper(location.pathname, 'account-activity')} data-qa-hook="orgManagementAcctShow.link" isChild={true} />
                  </NavList>
                </NavItem>
                :
                <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link" />
            )}
  
              <RedeemButton />
  
          </NavList>
        ) : (
        // DESKTOP NAV //
        <NavList isActive>
          <NavItem firstChild title="My Account" href={PATH_PERSONAL_ACCOUNT} data-qa-hook="personalAccount.link">
            <NavList>
              <NavItem title="Profile" href={PATH_PROFILE} data-qa-hook="profile.link" isChild={true} />
              <NavItem title="Addresses" href={PATH_USER_ADDRESS_MANAGEMENT} data-qa-hook="shippingAddresses.link" isChild={true} />
              <NavItem title="Subscriptions" href={PATH_SUBSCRIPTIONS} data-qa-hook="subscriptions.link" isChild={true} />
              <NavItem title="Payment Methods" href={PATH_PAYMENT_METHODS} data-qa-hook="creditCards.link" isChild={true} />
              <NavItem title="Gift Cards" href={PATH_GIFT_CARDS} data-qa-hook="paymentMethodsGiftCards.link" isChild={true} />
            </NavList>
          </NavItem>
          <NavItem title="Orders & Autoship" href={PATH_ORDER_HISTORY} auxiliaryRoutes={[PATH_AUTOSHIP]} data-qa-hook="orderHistory.link" />
          <NavItem title="Digital Library" href={PATH_DIGITAL_MEDIA} data-qa-hook="mediaContent.link" />
          <NavItem title="Manage Access" href={PATH_MANAGE_ACCESS} data-qa-hook="manageAccss.link" />
          {!ENABLE_ORG_MANAGEMENT && (
            isOnOrg ?
              <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link">
                <NavList>
                  <NavItem title="All Accounts" href={`${PATH_ORG_MGMT}/billing-accounts`} data-qa-hook="orgManagement.link" isChild={true} />
                  <NavItem title="Order History" href={regExBillingAccountPathHelper(location.pathname, 'order-history')} data-qa-hook="orgManagementOrderHistory.link" isChild={true} />
                  <NavItem title="Account Activity" href={regExBillingAccountPathHelper(location.pathname, 'account-activity')} data-qa-hook="orgManagementAcctShow.link" isChild={true} />
                </NavList>
              </NavItem>
              :
              <NavItem title="Org. Management" href={PATH_ORG_MGMT} data-qa-hook="orgManagement.link" />
          )}
              <RedeemButton />
        </NavList>
      ));

    const _crumbs = [];
    const navMenu = setActiveItems(ENABLE_SIDENAV_MENU ? updatedMenu : menu, this.props, 0, false, _crumbs);
    return navMenu;
  }
}

const { object, func, bool, shape, node, string, array } = PropTypes;

PersonNavMenu.propTypes = {
  location: object.isRequired,
  navToggle: func,
  isOpen: bool,
  isMobile: bool,

  // are used on mobile to create the breadcrumb menu (in setActiveItems)
  isBreadCrumb: bool,
  renderBreadCrumb: func,

  icons: shape({
    iconActive: node,
    iconInactive: node
  }),
  // Will warn sometimes until all are changed to Styled-Components: string VS array //
  styles: shape({
    ulCommon: oneOfType([array, string]),
    ulActive: oneOfType([array, string]),
    ulInactive: oneOfType([array, string]),
    liCommon: oneOfType([array, string]),
    liActive: oneOfType([array, string]),
    liInactive: oneOfType([array, string]),
    aCommon: oneOfType([array, string]),
    aActive: oneOfType([array, string]),
    aInactive: oneOfType([array, string]),
    firstChildStyles: object,
    lastChildStyles: object,
  })
};
